import settings from '@/settings'
import i18n from '@/i18n'
import Vue from 'vue'
import store from './store/'

export default {
	sanitize (value) {
		var rst = value;
		if (!rst || !isFinite(rst) || isNaN(rst) || rst.length == 0) rst = 0;
		return rst;
	},
	format(v, u) {
		var rst = v;
		var unit = settings.data.units.find(e => e.name === u);
		if (unit) {
			rst = rst.toFixed(unit.decimals);
		}

		return rst;
	},
	loadSettings() {
		Vue.storage.getItem('settings').then((data) => {
			if (data) {
				try {
					settings.data = JSON.parse(data);
					i18n.locale = settings.data.language;
					return;
				} catch(e) {
					Vue.storage.removeItem('settings');
				}
			}
			var localeLanguage = 'en-US';
			if (window.Intl && typeof window.Intl === 'object') {
				localeLanguage = navigator.language;
			}
			settings.data.language = localeLanguage;
			settings.data.defaultYarnCount = 'nm';
			settings.data.defaultYarnType = 'needles-head';
			this.saveSettings();
		});
	},
	saveSettings() {
		var parsed = JSON.stringify(settings.data);
		Vue.storage.setItem('settings', parsed);
		i18n.locale = settings.data.language;
	},
	autoLogin(token) {
		return new Promise((resolve, reject) => {
			if (token) {
				store.commit('authSuccess', {token: token});
				store.dispatch('userRequest')
				.then(() => {
					resolve();
				})
				.catch((err) => {
					// store.dispatch('authError', {err: err});
					reject(err);
				});
			} else {
				resolve();
			}
		});
	}
}